export default "__VITE_ASSET__Cb0VVvFA__"